import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import { AIChat } from "@/components/AIChat";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Projects from "@/pages/Projects";
import ProjectDetails from "@/pages/ProjectDetails";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import EMICalculator from "@/pages/EMICalculator";
import Contact from "@/pages/Contact";
import BookVisit from "@/pages/BookVisit";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main className="pt-[72px] min-h-screen">{children}</main>
    <Footer />
    <WhatsAppFab />
    <AIChat />
  </>
);

const Shell = () => {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/dashboard");
  if (isAdmin) {
    return (
      <Routes>
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      </Routes>
    );
  }
  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:slug" element={<ProjectDetails />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/emi-calculator" element={<EMICalculator />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book-visit" element={<BookVisit />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </PublicLayout>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
